export const WhitelistType = {
  EMAIL: 'Email',
  PHONE: 'Phone',
};
